export const ACTIVE_PLAYER = "ACTIVE_PLAYER";
export const ACTIVE_COURSES = "ACTIVE_COURSES";
export const CLUB_COURSES_DATA = "CLUB_COURSES_DATA";
